export const notFoundView = {
  'not-found-view.heading': 'Oops! Nothing to see here.',
  'not-found-view.text':
    'We ran into an issue. Let’s get you back to the good stuff.',
  'not-found-view.return-home': 'Return home',
  'not-found-view.select-another-location': 'Select another location',
  'not-found-view.empty-cart': 'Choose a location',
  'not-found-view.logged-out-checkout': 'Login to finish your order',
};
